import { RouteProps } from "react-router";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  platform: selectors.getPlatform(state),
  isBusinessAccount: selectors.getIsBusinessAccount(state),
  isDeclinedKYC: selectors.isDeclinedKYC(state)
});

const mapDispatchToProps = {
  getDashboardStatistics: actions.getDashboardStatistics,
  switchPlatform: actions.switchPlatform,
  toggleModal: actions.toggleModal
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
